export const CART_API_PATHS = {
  cart: '/cart',
  items: '/cart/items',
  item: (productId: string) => `/cart/items/${encodeURIComponent(productId)}`,
  merge: '/cart/merge',
} as const

export const COUPON_API_PATHS = {
  available: '/coupons/available',
  guest: '/coupons/guest',
  validate: '/coupons/validate',
  apply: '/coupons/apply',
  remove: '/coupons/remove',
} as const

export const WISHLIST_API_PATHS = {
  list: '/wishlist',
  items: '/wishlist/items',
  item: (productId: string) => `/wishlist/items/${encodeURIComponent(productId)}`,
  merge: '/wishlist/merge',
} as const
export const CAR_API_PATHS = {
  makes: '/cars/makes',
  models: (make: string) => `/cars/models?make=${encodeURIComponent(make)}`,
  years: (make: string, model: string) =>
    `/cars/years?make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}`,
  variants: (make: string, model: string, year: number) =>
    `/cars/variants?make=${encodeURIComponent(make)}&model=${encodeURIComponent(
      model,
    )}&year=${year}`,
} as const

export const USER_CAR_API_PATHS = {
  validate: '/user/cars/validate',
  root: '/user/cars',
  detail: (userCarId: string) => `/user/cars/${encodeURIComponent(userCarId)}`,
} as const

export const ADDRESSES_API_PATHS = {
  list: '/addresses',
  detail: (addressId: string) => `/addresses/${encodeURIComponent(addressId)}`,
} as const

export const PLACES_API_PATHS = {
  serviceAvailability: (pin: string) => `/places/service-availability?pin=${pin}`,
} as const

export const SHIPPING_API_PATHS = {
  rate: '/shipping/rate',
} as const

export const IMAGE_API_PATHS = {
  upload: '/images/upload',
} as const
